import RouterConfig from 'RouterConfig'
import { Worker } from 'core/Worker'
import { Suspense } from 'react'
function App() {
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Suspense fallback={''}>
        <RouterConfig />
      </Suspense>
    </Worker>
  )
}

export default App
